//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        computed: {
            searchResults: function () {
                return this.$store.state.results.itemResults;
            },
            settings: function () {
                return this.$store.state.settings;
            },

        },
        methods: {
            getAriaText: function (item) {
                if (item != null) {
                    return "Click to go to " + item.title;
                } else {
                    return "";
                }
            }
        }
    }
